exports["Dictionary"] = Dictionary;
exports["minify"] = minify;
exports["parse"] = parse;
exports["push_uniq"] = push_uniq;
exports["OutputStream"] = OutputStream;
exports["TreeTransformer"] = TreeTransformer;
exports["TreeWalker"] = TreeWalker;
